import $ from "jquery";

$('.searchtml-homepage__form-tml select').on('change', function (e) {
  var target = $(this).val();
  var pubmed = {
    target: 'https://apps.library.vcu.edu/assets/shared/includes/search.php',
    placeholder: 'Search PubMed',
    labelText: 'Search PubMed',
    type: 'pubmed'
  };

  var vcu_search = {
    target: 'https://apps.library.vcu.edu/assets/shared/includes/search.php',
    placeholder: 'Search articles, journals, books, media and more',
    labelText: 'Search',
    type: 'quicksearch'
  };

  if (target === 'PubMed') {
    $(document.getElementById("search").style.backgroundColor = "#006894");
    $(document.getElementById("tmlquicklink1").style.backgroundColor = "#0081B8");
    $(document.getElementById("tmlquicklink2").style.backgroundColor = "#0081B8");
    $(document.getElementById("tmlquicklink3").style.backgroundColor = "#0081B8");
    $(document.getElementById("tmlquicklink4").style.backgroundColor = "#0081B8");
    $(document.getElementById("tmlquicklink5").style.backgroundColor = "#0081B8");
    $(document.getElementById("tmlquicklink6").style.backgroundColor = "#0081B8");
    $(document.getElementById("tmladvanced").style.backgroundColor = "#006894");
    $(document.getElementById("tmlquicklink1text").style.color = "white");
    $(document.getElementById("tmlquicklink2text").style.color = "white");
    $(document.getElementById("tmlquicklink3text").style.color = "white");
    $(document.getElementById("tmlquicklink4text").style.color = "white");
    $(document.getElementById("tmlquicklink5text").style.color = "white");
    $(document.getElementById("tmlquicklink6text").style.color = "white");
    $(document.getElementById("tmlquicklinkadvancedtext").style.color = "white");
    $('form.searchtml-homepage__form-tml').attr('action', pubmed.target);
    $('form.searchtml-homepage__form-tml input[name=quicksearch_type]').attr('value', pubmed.type);
    $('form.searchtml-homepage__form-tml label').html(pubmed.labelText);
    $('form.searchtml-homepage__form-tml input[name=search_field]').attr('placeholder', pubmed.placeholder);
    $('form.searchtml-homepage__form-tml input[name=search_field]').focus();
  } else if (target === 'VCU Libraries') {
    $('form.searchtml-homepage__form-tml').attr('action', vcu_search.target);
    $('form.searchtml-homepage__form-tml input[name=quicksearch_type]').attr('value', vcu_search.type);
    $('form.searchtml-homepage__form-tml label').html(vcu_search.labelText);
    $('form.searchtml-homepage__form-tml input[name=search_field]').attr('placeholder', vcu_search.placeholder);
    $('form.searchtml-homepage__form-tml input[name=search_field]').focus();
    $(document.getElementById("search").style.backgroundColor = "#F8B300");
    $(document.getElementById("tmlquicklink1").style.backgroundColor = "#FFC01E");
    $(document.getElementById("tmlquicklink2").style.backgroundColor = "#FFC01E");
    $(document.getElementById("tmlquicklink3").style.backgroundColor = "#FFC01E");
    $(document.getElementById("tmlquicklink4").style.backgroundColor = "#FFC01E");
    $(document.getElementById("tmlquicklink5").style.backgroundColor = "#FFC01E");
    $(document.getElementById("tmlquicklink6").style.backgroundColor = "#FFC01E");
    $(document.getElementById("tmladvanced").style.backgroundColor = "#F8B300");
    $(document.getElementById("tmlquicklink1text").style.color = "black");
    $(document.getElementById("tmlquicklink2text").style.color = "black");
    $(document.getElementById("tmlquicklink3text").style.color = "black");
    $(document.getElementById("tmlquicklink4text").style.color = "black");
    $(document.getElementById("tmlquicklink5text").style.color = "black");
    $(document.getElementById("tmlquicklink6text").style.color = "black");
    $(document.getElementById("tmlquicklinkadvancedtext").style.color = "black");
  }
});
